@let stage = store.stageSg();

@switch (stage) {
  @case ('packages') {
    <atn-quiver-deployment-modal-packages-step />
  }
  @case ('resources') {
    <atn-quiver-deployment-modal-resources-step />
  }
  @case ('evaluation') {
    <atn-quiver-deployment-modal-evaluation-step />
  }
}
